import { AuthRepository } from "../repository/auth_repository";
import { clearSession } from "../utils/session";

export class AuthService {
	constructor() {
		this.authRepository = new AuthRepository();
	}

	async authenticate(username, password) {
		const accessToken = await this.authRepository.authenticate(username, password);
		// Zera o que sobrou da sessão anterior antes de gravar o novo token: a
		// unidade/empresa selecionadas são de outro usuário e, se ficarem, vão
		// junto na primeira requisição e voltam 403.
		clearSession();
		localStorage.setItem("access_token", accessToken);
	}

	async getProfile() {
		// O perfil é mantido em memória pelo UserContext, não em localStorage,
		// para não persistir dados pessoais (nome, CPF/CNPJ) em disco.
		return await this.authRepository.getProfile();
	}

	async getAccount() {
		return await this.authRepository.getAccount();
	}

	async updateAccount(data) {
		return await this.authRepository.updateAccount(data);
	}

	async changePassword(senhaAtual, novaSenha) {
		return await this.authRepository.changePassword(senhaAtual, novaSenha);
	}

	async sendResetPasswordToken(username) {
		return await this.authRepository.sendResetPasswordToken(username);
	}

	async resetPasswordWithToken(body) {
		return await this.authRepository.resetPasswordWithToken(body);
	}
}
